export default __webpack_public_path__ + "static/media/img-57.44e19995.jpg";